export class DynamicControl<T> {
    value: T;
    key: string;
    label: string;
    required: boolean;
    order: number;
    controlType: string;
    viewState: string;
    rangeValues: { min: string, max: string };
    regex: string;
    MOD97: boolean;
    valueOptions: Array<string>;
    children: any[];

    constructor(options: {
        value?: T,
        key?: string,
        label?: string,
        required?: boolean,
        order?: number,
        controlType?: string,
        viewState?: string,
        rangeValues?: {min: string, max: string},
        valueOptions?: Array<string>,
        regex?: string,
        MOD97?: boolean,
        children?: any[]
      } = {}) {
      this.value = options.value;
      this.key = options.key || '';
      this.label = options.label || '';
      this.required = !!options.required;
      this.order = options.order === undefined ? 1 : options.order;
      this.controlType = options.controlType || '';
      this.viewState = options.viewState || '';
      this.rangeValues = options.rangeValues || null;
      this.regex = options.regex || null;
      this.valueOptions = options.valueOptions || null;
      this.MOD97 = options.MOD97 || null;
      this.children = options.children || null;
    }
  }
